import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        docId:0,
        caseId:-1,
        openId:"",
        playerId:"",
        ksd_pdf:"",
        ksd_docId:'',
        ksd_judgeId:''
    },
    getters:{
        getDocId(state){
            return state.docId
        }
    },
    mutations: {
        setDocId(state,docId){
            state.docId  = docId
        }
    },
    actions: {
    }
  })